import { gql } from '@apollo/client';
import { GOALIE_STATS_FRAGMENT, PLAYER_INFO_FRAGMENT } from '../../fragments';

export const GET_STATS_GOALIE = gql`
  ${GOALIE_STATS_FRAGMENT}
  ${PLAYER_INFO_FRAGMENT}
  query GetStats($seasonId: Int) {
    careerStatsGoalie(where: { seasonBySeason: { id: { _eq: $seasonId } } }) {
      ...GoalieStats
      playerByPlayer {
        ...PlayerInfo
      }
      seasonBySeason {
        year
        season
      }
      teamByTeam {
        abbreviation
        color
        colorSecondary
        champion
        id
        name
      }
    }
  }
`;
